import React, { useEffect, useState } from 'react';
import moment from "moment";
import history from "../../utilities/history";
// import Datatable from "../../components/Datatable"
import Pagination from '../Datatable/Pagination';
import {
  caseStatusInitialPagination,
  MODAL_SIZE,
  USER_ROLES,
  ADMIN_ROLES_FOR_ADMIN_SECTION
} from "../../App.config";
import ConfirmationModalPopup from "../../containers/Std/ConfirmationModalPopup";
import ChangePasswordModal from "../../containers/UserForm/changePasswordModal";
import DomainList from "../../containers/DomainList";
import DropdownComponent from "../../containers/Dropdown";
import * as utilities from "../../utilities/utils";
import backArrow from "../../images/back-arrow.svg";
import CompanyServices from '../CompanyServices';
import UploadSvg from "../../images/upload.svg";
import swal from 'sweetalert';
import D3 from "../../Docs/ABCUserData.xlsx";
import UploadUserModal from "../../containers/UserList/uploadUserModal"
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";


const UserListComponent = (props) => {
  const [currentPage, setCurrentPage] = useState(caseStatusInitialPagination.pageNo);
  const [pageSize, setPageSize] = useState(caseStatusInitialPagination.pageSize);
  const [totalRows, setTotalRows] = useState(caseStatusInitialPagination.totalRows);
  const [serchvalue, setSerchvalue] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedAuthUserId, setSelectedAuthUserId] = useState(null);
  const [selectedTerminationStatus, setSelectedTerminationStatus] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState(0);


  useEffect(() => {
    if (!props.userAuthReducer.selectedCompany) {
      props.getAllAuthUsers(props.userAuthReducer.selectedCompany, 1, pageSize, null, null, null, null, selectedRoleId);
    }
  }, [props.userAuthReducer.selectedCompany])

  useEffect(() => {
    // if (selectedCompany)
    props.getAuthUserRoles(0);
    // props.getAllAuthUsers()
    !props.userAuthReducer.selectedCompany && props.getAllAuthUsers(props.userAuthReducer.selectedCompany, 1, pageSize, null, null, null, null, selectedRoleId);

  }, [
    // selectedCompany
  ]);

  useEffect(() => {
    props.getAllCompanyList();
  }, []);

  useEffect(() => {
    return function cleanup() {
      setSelectedCompany(null);
    };
  }, []);

  useEffect(() => {
    if (props.userAuthReducer.selectedCompany) {
      // props.getCompanyServiceSettings(props.userAuthReducer.selectedCompany);
      setSelectedCompany(props.userAuthReducer.selectedCompany);
      setTotalRows(props.userAuthReducer.totalRecord);
      setCurrentPage(1);
      props.userAuthReducer.selectedCompany && props.getAllAuthUsers(props.userAuthReducer.selectedCompany, 1, pageSize, null, null, null, null, selectedRoleId);
      !props.userAuthReducer.selectedCompany && props.getAllAuthUsers(null, 1, pageSize, null, null, null, null, selectedRoleId);
    }
    else
      setSelectedCompany(null);
  }, [props.userAuthReducer.selectedCompany])

  useEffect(() => {
    if (props.userAuthReducer.totalRecord) {
      setTotalRows(props.userAuthReducer.totalRecord);
    }
  }, [props.userAuthReducer.totalRecord]);

  useEffect(() => {
    if (props.userAuthReducer.domainFlag && selectedCompany) {
      props.resetDomainFlag(false);
      props.openSetModalAction(<DomainList />, MODAL_SIZE.MODAL_MD);
    }
    else {
      props.resetDomainFlag(false);
    }
  }, [props.userAuthReducer.domainFlag]);

  const onServiceBtnClick = () => {
    props.getCompanyServiceSettings(selectedCompany);
    props.openSetModalAction(<CompanyServices companyServices={props.userAuthReducer.companyServices}
      saveCompanyServiceSetting={props.saveCompanyServiceSetting}
      closeRemoveModal={props.closeRemoveModal}
      selectedCompany={selectedCompany}
      context={props.context}
    />, MODAL_SIZE.MODAL_SM);
  }

  useEffect(() => {
    // if (props.userAuthReducer.companyServices && selectedCompany)

    // else
    //   props.closeRemoveModal();
  }, [props.userAuthReducer.companyServices]);

  useEffect(() => {
    if (props.userAuthReducer.isUserDelete) {
      setTotalRows(props.userAuthReducer.totalRecord);
      props.resetIsUserDelete();
      setCurrentPage(1);
      selectedCompany && props.getAllAuthUsers(selectedCompany, 1, pageSize, serchvalue, null, null, null, selectedRoleId);
      !selectedCompany && props.getAllAuthUsers(null, 1, pageSize, serchvalue, null, null, null, selectedRoleId);

    }
  }, [props.userAuthReducer.isUserDelete]);

  useEffect(() => {
    if (props.userAuthReducer.isBackupAssigned && props.userAuthReducer.successMessageForBackupUserAssigned) {
      props.openSetModalAction(
        <ConfirmationModalPopup
          {...props}
          confirmationMessage="Are you sure do you want to change terminate status?"
          onYesClick={() => {
            props.changeTerminationStatus(selectedAuthUserId, selectedTerminationStatus)
            selectedCompany && props.getAllAuthUsers(selectedCompany, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId)
            !selectedCompany && props.getAllAuthUsers(null, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId);

            props.closeRemoveModal();
          }}
        />,
        MODAL_SIZE.MODAL_SM
      );
      props.resetIsUserAssignAsBackup();
      props.resetsuccessMessageForBackupUserAssigned();
    }
  }, [props.userAuthReducer.successMessageForBackupUserAssigned]);

  useEffect(() => {
    if (props.userAuthReducer.openSimpleModalForTermiantion) {
      props.openSetModalAction(
        <ConfirmationModalPopup
          {...props}
          confirmationMessage="Are you sure do you want to change terminate status?"
          onYesClick={() => {
            props.changeTerminationStatus(selectedAuthUserId, selectedTerminationStatus)
            selectedCompany && props.getAllAuthUsers(selectedCompany, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId)
            !selectedCompany && props.getAllAuthUsers(null, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId);
            props.closeRemoveModal();
          }}
        />,
        MODAL_SIZE.MODAL_SM
      );
      props.resetOpenSimpleModalForTermiantion();
    }
    // selectedAuthUserId = null;
    // selectedTerminationStatus = null;
    setSelectedAuthUserId(null);
    setSelectedTerminationStatus(null);
  }, [props.userAuthReducer.openSimpleModalForTermiantion])


  const onDomainClick = () => {
    props.getAllDomainList(selectedCompany);
  }



  const onAddUserClick = (isAdmin) => {
    history.push({
      pathname: "/add-user-form",
      state: { isAdmin: isAdmin }
    });
  }

  const onAddBrokerUserClick = () => {
    history.push({
      pathname: "/add-user-form",
      state: { isBroker: true }
    });
  }
  // history.push({pathname:"/add-user-form",state: { key: key }});
  const onUpdateClick = (authUserId) => history.push("/update-user-form?authUserId=" + authUserId);
  const onUpdateSpecialCase = (authUserId, userRoleId) => {
    if (userRoleId == USER_ROLES.ADMIN) {
      history.push({
        pathname: "/update-user-form",
        state: { isAdmin: true, authUserId: authUserId }
      });
    }
    else if (userRoleId == USER_ROLES.BROKER) {
      history.push({
        pathname: "/update-user-form",
        state: { isBroker: true, authUserId: authUserId }
      });
    }
  }
  const onChangePasswordClick = (authUserId) => {
    props.openSetModalAction(
      <ChangePasswordModal
        {...props}
        authUserId={authUserId}
        callApiText={"UserList"}
      />,
      MODAL_SIZE.MODAL_SM
    );
  }

  const openImportUserModal = () => {
    props.openSetModalAction(<UploadUserModal {...props} selectedCompany={selectedCompany} />, MODAL_SIZE.MODAL_SM);
  }

  const onChange = (event) => {
    setCurrentPage(event.target.value);
    selectedCompany && props.getAllAuthUsers(selectedCompany, event.target.value, pageSize, serchvalue, null, null, null, selectedRoleId);
    !selectedCompany && props.getAllAuthUsers(null, event.target.value, pageSize, serchvalue, null, null, null, selectedRoleId);
  }

  const onChangeSerachValue = (event) => {
    setSerchvalue(event.target.value);
    selectedCompany && props.getAllAuthUsers(selectedCompany, currentPage, pageSize, event.target.value, null, null, null, selectedRoleId);
    !selectedCompany && props.getAllAuthUsers(null, currentPage, pageSize, event.target.value, null, null, null, selectedRoleId);
    setCurrentPage(1);
  }

  const checkIsUserAssignAsBackup = (authUserId, terminationStatus) => {
    // selectedAuthUserId = authUserId;
    // selectedTerminationStatus = terminationStatus;
    setSelectedAuthUserId(authUserId);
    setSelectedTerminationStatus(terminationStatus);
    props.checkIsUserAssignAsBackup(authUserId);
  }

  const changeTerminationStatus = (authUserId, terminationStatus) => {
    props.openSetModalAction(
      <ConfirmationModalPopup
        {...props}
        confirmationMessage="Are you sure do you want to change terminate status?"
        onYesClick={() => {
          props.changeTerminationStatus(authUserId, terminationStatus)
          selectedCompany && props.getAllAuthUsers(selectedCompany, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId)
          !selectedCompany && props.getAllAuthUsers(null, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId);

          props.closeRemoveModal();
        }}
      />,
      MODAL_SIZE.MODAL_SM
    );
  }

  const changeLockStatus = (authUserId, lockStatus) => {
    props.openSetModalAction(
      <ConfirmationModalPopup
        {...props}
        confirmationMessage="Are you sure do you want to change lock status?"
        onYesClick={() => {
          props.changeLockStatus(authUserId, lockStatus);
          selectedCompany && props.getAllAuthUsers(selectedCompany, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId);
          !selectedCompany && props.getAllAuthUsers(null, currentPage, pageSize, serchvalue, null, null, null, selectedRoleId);
          props.closeRemoveModal();
        }}
      />,
      MODAL_SIZE.MODAL_SM
    );
  }

  const onDropDownChange = (event) => {
    setSelectedRoleId(0);
    setSelectedCompany(utilities.extractFirstValueOfArray(event.value));
    if (utilities.extractFirstValueOfArray(event.value)) {
      utilities.extractFirstValueOfArray(event.value) && props.getAllAuthUsers(utilities.extractFirstValueOfArray(event.value), currentPage, pageSize, null, null, null, null, selectedRoleId);
      !utilities.extractFirstValueOfArray(event.value) && props.getAllAuthUsers(null, currentPage, pageSize, null, null, null, null, selectedRoleId);

    }
    else {
      props.setSelectedCompany(null);
      setTotalRows(0);
    }
  }


  const normalizeInput = (value, previousValue) => {
    if (!value) return value;
    //remove any charater without alphnumeric
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      } else if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
      } else {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(
          3,
          6
        )}-${currentValue.slice(6, 10)}`;
      }
    }
  };

  const onRoleChange = (e) => {
    selectedCompany && props.getAllAuthUsers(selectedCompany, 1, pageSize, serchvalue, null, null, null, e.target.value);
    !selectedCompany && props.getAllAuthUsers(null, 1, pageSize, serchvalue, null, null, null, e.target.value);
    setSelectedRoleId(e.target.value);
    // console.log("you selected - " + e.target.value);
  }

  return (
    <>

      <div className="Card-panel">
        <DisplayEmployeeName context={props.context} />
        <div className="Table-list">
          <div className='row'>
            <div className="col-md-1">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={() => history.push("/dashboard")}
                src={backArrow}
                alt="back-arrow"
              />
            </div>
          </div>
          <div className='card'>
            <div className='card-body'>
              <div className="row">
                <div className="col-md-8 mb-3">
                  <label>Select Company</label>
                  <DropdownComponent
                    name="companyList"
                    options={props.userAuthReducer.companyList}
                    isMultiSelect={false}
                    option_key="companyId"
                    option_display="companyName"
                    onChange={onDropDownChange}
                    values={[selectedCompany]}
                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                    selectAllText="Select All Options"
                    isSearchOption={true}
                    searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                  // ref={state.location.ref}
                  />
                </div>
                {!selectedCompany && <div className="col-md-4 mt-31 d-inline-block">
                  <button type="button" className="btn btn-primary w-13 mr-2" onClick={() => onAddUserClick(true)}>Add Admin</button>
                  <button type="button" className="btn btn-primary w-13" onClick={() => onAddBrokerUserClick()}>Add Broker</button>
                </div>}
              </div>
              <div className="row">
                <div className="col-md-5 mb-3">
                  <div className="form-outline">
                    <input id="search-input" type="search" id="form1" className="form-control" placeholder="Search..."
                      onChange={onChangeSerachValue}
                    />
                  </div>
                </div>
                <div className="form-outline">
                  {!selectedCompany ?
                    <select className="form-control" onChange={onRoleChange} value={selectedRoleId}>
                      <option value={0}>-:Select Option:-</option>
                      <option value={USER_ROLES.ADMIN}>Administrator</option>
                      <option value={USER_ROLES.BROKER}>Broker</option>
                    </select> :
                    <select className="form-control" onChange={onRoleChange} value={selectedRoleId}>
                      <option value={0}>-:Select Option:-</option>
                      <option value={USER_ROLES.FULL_HR}>FULL HR</option>
                      <option value={USER_ROLES.LIMITED_CAL_HR}>LIMITED CAL HR</option>
                      <option value={USER_ROLES.LIMITED_CAL_MGR}>MANAGER</option>
                    </select>}
                </div>
              </div>
            </div>
          </div>

          {selectedCompany && <div className='row mt-2'>
            <div className="col-md-12 text-right">
              <div className="mb-2 mr-1 d-inline-block">
                <button type="button" className="btn btn-primary w-9" onClick={() => openImportUserModal()}>Import Users</button>
              </div>
              <div className="mb-2 mr-1 d-inline-block">
                <button type="button" className="btn btn-primary w-9" onClick={() => onDomainClick()}>Domain List</button>
              </div>
              <div className="mb-2 mr-1 d-inline-block">
                <button type="button" className="btn btn-primary w-9" onClick={() => onServiceBtnClick()}>Services</button>
              </div>
              <div className="mb-2 d-inline-block">
                <button type="button" className="btn btn-primary w-9" onClick={() => onAddUserClick(false)}>Add User</button>
              </div>
            </div>
          </div>}

          {selectedCompany &&
            <div className="Table-cell table-responsive pl-1 mt-2">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th colSpan="4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {props.userAuthReducer && props.userAuthReducer.allAuthUsers.length > 0 ? props.userAuthReducer.allAuthUsers.map((authUser, i) => (
                    <tr key={authUser.authUserId}>
                      <td>{authUser.firstName}{authUser.isTerminated && " [TERMINATED]"}</td>
                      <td>{authUser.lastName}</td>
                      <td>{normalizeInput(authUser.phone)}</td>
                      <td>{authUser.email}</td>
                      <td>
                        {ADMIN_ROLES_FOR_ADMIN_SECTION.map(function (item) {
                          if (item.authUserRoleId == authUser.userRoleId)
                            return (<div>
                              {item.name}{authUser.userRoleId == USER_ROLES.BROKER && <span className="text-success">*</span>}</div>
                            )
                        })}
                      </td>
                      <td><button type="button" className="btn-primary table-button update" onClick={() => onUpdateClick(authUser.authUserId)}>Update</button></td>
                      <td><button type="button" className="btn-primary table-button delete" onClick={() => onChangePasswordClick(authUser.authUserId)}>Change Password</button></td>
                      {authUser.isTerminated ? <td><button type="button" className="btn-primary table-button terminate" onClick={() => changeTerminationStatus(authUser.authUserId, false)}>Terminated</button></td> : <td><button type="button" className="btn-primary table-button terminate" onClick={() => checkIsUserAssignAsBackup(authUser.authUserId, true)}>Terminate</button></td>}
                      {authUser.isLocked ? <td><button type="button" className="btn-primary table-button lock" onClick={() => changeLockStatus(authUser.authUserId, false)}>Unlock</button></td> : <td><button type="button" className="btn-primary table-button lock" onClick={() => changeLockStatus(authUser.authUserId, true)}>Lock</button></td>}
                    </tr>
                  )) :
                    <tr><td colSpan="6" className="text-center">No data found</td></tr>}

                </tbody>
              </table>
            </div>}
          {!selectedCompany &&
            <div className="Table-cell table-responsive pl-1 mt-2">
              <table className="table table-bordered">
                <thead>
                  <tr><th colSpan="9" className="text-center">Admin Users/Broker Users</th></tr>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th colSpan="4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {props.userAuthReducer && props.userAuthReducer.allAuthUsers.length > 0 ? props.userAuthReducer.allAuthUsers.map((authUser, i) => (
                    <tr key={authUser.authUserId}>
                      <td>{authUser.firstName}</td>
                      <td>{authUser.lastName}</td>
                      <td>{normalizeInput(authUser.phone)}</td>
                      <td>{authUser.email}</td>
                      <td>{ADMIN_ROLES_FOR_ADMIN_SECTION.map(function (item) { if (item.authUserRoleId == authUser.userRoleId) return item.name })}</td>
                      <td><button type="button" className="btn-primary table-button update" onClick={() => onUpdateSpecialCase(authUser.authUserId, authUser.userRoleId)}>Update</button></td>
                      <td><button type="button" className="btn-primary table-button delete" onClick={() => onChangePasswordClick(authUser.authUserId)}>Change Password</button></td>
                      {authUser.isTerminated ? <td><button type="button" className="btn-primary table-button terminate" onClick={() => changeTerminationStatus(authUser.authUserId, false)}>Terminated</button></td> : <td><button type="button" className="btn-primary table-button terminate" onClick={() => checkIsUserAssignAsBackup(authUser.authUserId, true)}>Terminate</button></td>}
                      {authUser.isLocked ? <td><button type="button" className="btn-primary table-button lock" onClick={() => changeLockStatus(authUser.authUserId, false)}>Unlock</button></td> : <td><button type="button" className="btn-primary table-button lock" onClick={() => changeLockStatus(authUser.authUserId, true)}>Lock</button></td>}
                    </tr>
                  )) :
                    <tr><td colSpan="6" className="text-center">No data found</td></tr>}

                </tbody>
              </table>
            </div>}
          {props.userAuthReducer && props.userAuthReducer.allAuthUsers.length > 0 &&
            <Pagination
              currentPage={currentPage}
              pageSize={pageSize}
              totalRows={totalRows}
              onClickPre={(pageNo) => {
                onChange({
                  target: {
                    name: "currentPage",
                    value: pageNo
                  }
                })
              }}
              onClickNext={(pageNo) => {
                onChange({
                  target: {
                    name: "currentPage",
                    value: pageNo
                  }
                })
              }}
              onClickPage={(pageNo) => {
                onChange({
                  target: {
                    name: "currentPage",
                    value: pageNo
                  }
                })
              }}
            ></Pagination>}
        </div>
      </div>
    </>

  )
}

export default UserListComponent;